import { Paysheet } from "@/modules/hrs/paysheets/types"
import { Http } from "@/network/http"
import { notificationAction } from "@/utils"
import { Filters, NotificationEnum, StatusEnum } from "@/utils/constants"

export const API_PREFIX_PATH = "/paysheets"

export const fetchPaySheets = async (filters?: Filters) => {
  return await Http.get(`${API_PREFIX_PATH}`, { params: filters })
}

export const fetchPaySheet = async (id: string) => {
  return await Http.get(`${API_PREFIX_PATH}/${id}`)
}

export const deletePaysheet = async (id: string) => {
  return await Http.post(`${API_PREFIX_PATH}/delete/${id}`)
}

export const createPaySheet = async (data?: Paysheet) => {
  return await Http.post(`${API_PREFIX_PATH}`, data)
}

export const updatePaySheet = async (id: string, data?: Paysheet) => {
  return await Http.put(`${API_PREFIX_PATH}/${id}`, data)
}

export const deletePaySheet = async (data: Paysheet) => {
  try {
    const updatedData = { ...data }
    if (!updatedData.id) return
    const response = await updatePaySheet(updatedData.id, { ...updatedData, status: StatusEnum.DELETED })
    if (response.statusCode === 200) {
      notificationAction(NotificationEnum.DELETED, NotificationEnum.SUCCESS)
    }
  } catch (error) {
    console.error("Addition failed:", error)
    notificationAction(`Lỗi ${error}`, NotificationEnum.ERROR)
  }
}
